export const getEventColor = (value) => {
  switch (true) {
    case value >= 80:
      return "#4b9d1a";
    case value >= 70:
      return "#60c624";
    case value >= 60:
      return "#fee132";
    case value >= 50:
      return "#f7563c";
    case value >= 40:
      return "#d42c26";
    default:
      return "#af1210";
  }
};

export const getTrypDistance = (meters) => {
  const km = Math.round(meters / 1000);
  return km < 1 ? `< 1 km` : `${km} km`;
};

// From: https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
export const getScrollbarWidth = () => {
  // Creating invisible container
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; // forcing scrollbar to appear
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement("div");
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
};

export const getDefaultValue = (value, values) => {
  return values.find((e) => {
    if (value === "") {
      return e.id === -1;
    } else {
      return e.id === value;
    }
  });
};

export const hexToRGBA = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const formatThousand = (value) => {
  if (value < 1000) {
    return value.toString();
  }

  return (value / 1000).toFixed(1) + "K";
};

/**
 * Formats the entries to a more readable format for campaign cards.
 * If the entries are 1000 or more, it will format them to 'X.Xk' or 'Xk'.
 * Otherwise, it will just return the entries as a string.
 *
 * @param {number} entries - The number of entries to format.
 * @returns {string} - The formatted entries as a string.
 */
export const formatCampaignEntries = (entries) => {
  let formattedEntries = entries;
  if (entries >= 1000) {
    const temp = Math.floor(Math.log10(entries));

    formattedEntries =
      temp === 3
        ? `${Math.round((entries / 1000) * 10) / 10}k`
        : `${Math.round(entries / 1000)}k`;
  }
  return formattedEntries.toString();
};
